import gql from 'graphql-tag';

import printProductDetails from '../fragments/printProductDetails';

const getPrintProducts = gql`
  query getPrintProducts(
    $print_partner_id: RecordID
    $is_standard: Boolean
    $name: String
  ) {
    printProducts(
      print_partner_id: $print_partner_id
      is_standard: $is_standard
      name: $name
      slice: { limit: 999 }
    ) {
      total
      records {
        ...printProductDetails
      }
    }
  }
  ${printProductDetails}
`;

export default getPrintProducts;
